import { render, staticRenderFns } from "./control-button.vue?vue&type=template&id=2abba073&scoped=true&"
import script from "./control-button.vue?vue&type=script&lang=js&"
export * from "./control-button.vue?vue&type=script&lang=js&"
import style0 from "./control-button.vue?vue&type=style&index=0&id=2abba073&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abba073",
  null
  
)

export default component.exports